import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.url,
    target: _ctx.externalIcon ? '_blank' : '_self',
    class: "focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-black"
  }, [
    _renderSlot(_ctx.$slots, "before"),
    _createElementVNode("span", {
      class: _normalizeClass(["font-semibold", { ..._ctx.borderClasses }])
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.url), 1)
      ])
    ], 2),
    _renderSlot(_ctx.$slots, "after", {}, () => [
      (_ctx.externalIcon)
        ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            "aria-label": "External link indicator",
            type: "solid",
            name: "external-link",
            class: "h-4 w-4 ml-1 inline"
          }))
        : _createCommentVNode("", true)
    ])
  ], 8, _hoisted_1))
}